import { ComponentStyle, Link, setHamburgerMenuState, useQuery, useTranslation } from '@/imports-files/components/hamburger-menu';
import {useQueryClient} from 'react-query';

export function HamburgerMenu()
{
    const { t, i18n }             =  useTranslation();
    const queryClient             =  useQueryClient();
   
    return( 
            <div className={ComponentStyle.HamburgerMenu__Section}>
               <div className={`hamburger-menu ${ComponentStyle.HamburgerMenu}`} onClick = { () => setHamburgerMenuState(queryClient)} >
                    <div className={ComponentStyle.HamburgerMenu__Rectangle}></div>
                    <div className={ComponentStyle.HamburgerMenu__Rectangle}></div>
                    <div className={ComponentStyle.HamburgerMenu__Rectangle}></div>
                </div>
            </div>
          );
}